"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
// @ts-check

var keys = Object.keys;
var isArray = Array.isArray;

/**
 * @param {any} [arr]
 * @param {boolean|function(any):boolean} [undefinedOnly]
 * @param {any[]} [excludeKey]
 * @returns {any}
 */
var removeEmpty = function removeEmpty(arr, undefinedOnly, excludeKey) {
  if (!arr) {
    return arr;
  }
  if (undefinedOnly && _reshowConstant.FUNCTION !== typeof undefinedOnly) {
    undefinedOnly = function undefinedOnly(value) {
      return _reshowConstant.UNDEFINED !== typeof value;
    };
  }
  var result = {};
  keys(arr).forEach(function (key) {
    var value = arr[key];
    if (excludeKey && excludeKey.length && -1 !== excludeKey.indexOf(key)) {
      return;
    }
    if (value || undefinedOnly && /** @type function*/undefinedOnly(value)) {
      result[key] = value;
    }
  });
  if (isArray(arr)) {
    return keys(result).map(function (key) {
      return result[key];
    });
  } else {
    return result;
  }
};
var _default = removeEmpty;
exports["default"] = _default;
module.exports = exports.default;